import { Component, inject, output } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { MultiOrgFilterComponent } from '../multi-org-filter/multi-org-filter.component';
import { MultiOrgFilterTAComponent } from '../multi-org-filter-ta/multi-org-filter-ta.component';
import { CommonModule } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpinnerComponent } from 'src/app/modules/shared/components/spinner/spinner.component';

@Component({
    selector: 'app-role-request-advanced-search',
    imports: [ReactiveFormsModule, RouterModule, CommonModule, SpinnerComponent],
    templateUrl: './role-request-advanced-search.component.html',
    styleUrl: './role-request-advanced-search.component.css'
})
export class RoleRequestAdvancedSearchComponent {
  private roleRequestService = inject(RoleRequestService);
  private router = inject(Router);
  private spinner = inject(NgxSpinnerService);


  readonly onBack = output<any>();
  readonly emplSelected = output<any>();

  advancedSearchForm = new FormGroup({
    lastName: new FormControl('', Validators.required),
    dob:  new FormControl('', Validators.required),
    ssn4:  new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[0-9]*$')]),
  })

  searchData = []
  search(){
    const values = this.advancedSearchForm.value;
    this.spinner.show();
    this.roleRequestService.getPersonAdvancedSearch(values.lastName,values.dob, values.ssn4).subscribe((data) => {
      this.searchData = data;
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
    })
    
  }

  clear(){
    this.advancedSearchForm.reset();
  }

  onClickBack(){
    this.onBack.emit(null);
  }

  onEmployeeSelect(event){
    this.emplSelected.emit(event);
    this.onBack.emit(null);
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const pattern = /^[0-9]*$/;
    const inputChar = event.currentTarget['value'];
    if (!pattern.test(inputChar)) {
      this.advancedSearchForm.get('ssn4').setValue('');
    }
  }
}
